<template>
  <v-collapse-group>
    <v-collapse-wrapper :active="true">
      <div class="a-tab__title-block admin__a-tab admin__a-tab--modification-controls"
           v-collapse-toggle>
        <h3>{{$t('form.lot.lot-documentation')}}</h3>
      </div>
      <div class="admin__a-tab-content admin__a-tab-content--show" v-collapse-content>
        <div class="a-container-form a-container-form--align-start" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_STATISTICS">
          <div class="a-label a-label--w-280">{{$t('form.lot.persons-downloaded-docs')}}:</div>
          <div class="">
            <template v-if="lot.statistics.sawDocuments.length > 0">
              <expandable-list :value="lot.statistics.sawDocuments">
                <template v-slot:item="{ item }">
                  <p class="a-input a-input--disabled a-width-100-percent">
                    {{item.organization}} ({{item.email}})
                  </p>
                </template>
              </expandable-list>
            </template>
            <p class="a-input a-input--disabled a-width-100-percent" v-else>{{$t('form.lot.nobody')}}</p>
          </div>
        </div>
        <div class="a-container-form a-container-form--align-start" v-if="lot.files.length > 0">
          <div class="a-label a-label--w-280">{{$t('labels.files')}}:</div>
          <div class="">
            <file-link v-for="(file, idx) in lot.files"
                       :key="file.id"
                       :name="file.name"
                       :size="file.size"
                       :signed="file.hasSign"
                       @onsigncheck="onLotFileSignCheckClick(file.id)"
                       @click="onDownloadFileClick({fileId: file.id})">
            </file-link>
          </div>
        </div>
      </div>
    </v-collapse-wrapper>

    <template  v-if="lot.tenderFiles.length > 0">
      <v-collapse-wrapper :active="true">
        <div class="a-tab__title-block admin__a-tab admin__a-tab--modification-controls"
             v-collapse-toggle>
          <h3>{{$t('form.tender.tender-documents')}}</h3>
        </div>
        <div class="admin__a-tab-content admin__a-tab-content--show" v-collapse-content>
          <div class="a-container-form a-container-form--align-start">
            <div class="a-label a-label--w-280">{{$t('labels.files')}}:</div>
            <div class="a-flex-start">
              <file-link v-for="(file, idx) in lot.tenderFiles"
                         :key="file.id"
                         :name="file.name"
                         :size="file.size"
                         :signed="file.hasSign"
                         :link="externalLink(file.uid)"
                         @onsigncheck="onTenderFileSignCheckClick(file.id)">
              </file-link>
            </div>
          </div>
        </div>
      </v-collapse-wrapper>
    </template>

    <signature-details-dialog ref="signCheck"></signature-details-dialog>
  </v-collapse-group>
</template>

<script>
  import FileLink from '@/widgets/file-link'
  import SignatureDetailsDialog from '@/components/common/dialogs/SignatureDetailsDialog'

  export default {
    props: {
      lot: Object
    },

    components: {
      FileLink,
      SignatureDetailsDialog
    },

    methods: {
      async onDownloadFileClick({fileId}) {
        this.runAction(async() => {
          try {
            const link = await this.$store.dispatch('getDocumentLink', { lotId: this.lot.id, fileId });

            const elem = document.createElement('a');
            elem.href = this.externalLink(link);
            elem.setAttribute('target', '_blank');
            document.body.appendChild(elem);
            elem.click();
            elem.parentNode.removeChild(elem);
          }
          catch (e) {
            console.error('failed fetching file link', e);
            this.globalErrorHandler(e);
          }
        });
      },

      async onTenderFileSignCheckClick(fileId) {
        this.runAction(async () => {
          try {
            const signature = await this.$store.dispatch('checkTenderFileSignature', {
              tenderId: this.lot.tenderId,
              fileId: fileId
            });

            this.$refs.signCheck.open(signature);
          }
          catch(e) {
            console.error('failed checking tender file signature', e);
            this.globalErrorHandler(e);
          }
        })
      },

      async onLotFileSignCheckClick(fileId) {
        this.runAction(async () => {
          try {
            const signature = await this.$store.dispatch('checkLotFileSignature', {
              tenderId: this.lot.id,
              fileId: fileId
            });

            this.$refs.signCheck.open(signature);
          }
          catch(e) {
            console.error('failed checking lot file signature', e);
            this.globalErrorHandler(e);
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>
